// This file is auto-generated by update-translation-configuration script.
// Don't edit it manually, instead run `npm run update-translation-configuration`.

export enum Language {
    'da-DK' = 'da-DK',
    'de-DE' = 'de-DE',
    'en-GB' = 'en-GB',
    'es-ES' = 'es-ES',
    'fr-FR' = 'fr-FR',
    'is-IS' = 'is-IS',
    'no-NO' = 'no-NO',
    'pt-PT' = 'pt-PT',
    'ru-RU' = 'ru-RU',
    'zh-CN' = 'zh-CN',
}

export const languages = [
    Language['da-DK'],
    Language['de-DE'],
    Language['en-GB'],
    Language['es-ES'],
    Language['fr-FR'],
    Language['is-IS'],
    Language['no-NO'],
    Language['pt-PT'],
    Language['ru-RU'],
    Language['zh-CN'],
];
export const defaultLanguage = Language['en-GB'];

export { default as defaultDictionary } from '@/translations/modules/en-GB';

import adminApiTokensTranslations from '@/admin/api-tokens/i18n/translations.en-GB.json';
import adminBillingTranslations from '@/admin/billing/i18n/translations.en-GB.json';
import adminBrandingTranslations from '@/admin/branding/i18n/translations.en-GB.json';
import adminCategoriesTranslations from '@/admin/categories/i18n/translations.en-GB.json';
import adminCoursesTranslations from '@/admin/courses/i18n/translations.en-GB.json';
import adminEventsTranslations from '@/admin/events/i18n/translations.en-GB.json';
import adminGroupsTranslations from '@/admin/groups/i18n/translations.en-GB.json';
import adminTranslations from '@/admin/i18n/translations.en-GB.json';
import adminPlaylistsTranslations from '@/admin/playlists/i18n/translations.en-GB.json';
import adminSettingsTranslations from '@/admin/settings/i18n/translations.en-GB.json';
import adminSkillsTranslations from '@/admin/skills/i18n/translations.en-GB.json';
import adminTopicsTranslations from '@/admin/topics/i18n/translations.en-GB.json';
import adminUsersTranslations from '@/admin/users/i18n/translations.en-GB.json';
import authenticationTranslations from '@/authentication/i18n/translations.en-GB.json';
import commonComponentsTranslations from '@/common/components/i18n/translations.en-GB.json';
import commonTranslations from '@/common/i18n/translations.en-GB.json';
import contentStoreTranslations from '@/content-store/i18n/translations.en-GB.json';
import coursesTranslations from '@/courses/i18n/translations.en-GB.json';
import eventsTranslations from '@/events/i18n/translations.en-GB.json';
import notificationsTranslations from '@/notifications/i18n/translations.en-GB.json';
import openInAppTranslations from '@/open-in-app/i18n/translations.en-GB.json';
import profileSettingsTranslations from '@/profile-settings/i18n/translations.en-GB.json';
import reportingCommonTranslations from '@/reporting/i18n/common/translations.en-GB.json';
import reportingCourseReportTranslations from '@/reporting/i18n/course-report/translations.en-GB.json';
import reportingSegmentsTranslations from '@/reporting/i18n/segments/translations.en-GB.json';
import reportingSkillsReportTranslations from '@/reporting/i18n/skills-report/translations.en-GB.json';
import reportingUserGroupsReportTranslations from '@/reporting/i18n/user-groups-report/translations.en-GB.json';
import reportingUserReportTranslations from '@/reporting/i18n/user-report/translations.en-GB.json';

export type AdminApiTokensTranslationsKeys = keyof typeof adminApiTokensTranslations;
export type AdminBillingTranslationsKeys = keyof typeof adminBillingTranslations;
export type AdminBrandingTranslationsKeys = keyof typeof adminBrandingTranslations;
export type AdminCategoriesTranslationsKeys = keyof typeof adminCategoriesTranslations;
export type AdminCoursesTranslationsKeys = keyof typeof adminCoursesTranslations;
export type AdminEventsTranslationsKeys = keyof typeof adminEventsTranslations;
export type AdminGroupsTranslationsKeys = keyof typeof adminGroupsTranslations;
export type AdminTranslationsKeys = keyof typeof adminTranslations;
export type AdminPlaylistsTranslationsKeys = keyof typeof adminPlaylistsTranslations;
export type AdminSettingsTranslationsKeys = keyof typeof adminSettingsTranslations;
export type AdminSkillsTranslationsKeys = keyof typeof adminSkillsTranslations;
export type AdminTopicsTranslationsKeys = keyof typeof adminTopicsTranslations;
export type AdminUsersTranslationsKeys = keyof typeof adminUsersTranslations;
export type AuthenticationTranslationsKeys = keyof typeof authenticationTranslations;
export type CommonComponentsTranslationsKeys = keyof typeof commonComponentsTranslations;
export type CommonTranslationsKeys = keyof typeof commonTranslations;
export type ContentStoreTranslationsKeys = keyof typeof contentStoreTranslations;
export type CoursesTranslationsKeys = keyof typeof coursesTranslations;
export type EventsTranslationsKeys = keyof typeof eventsTranslations;
export type NotificationsTranslationsKeys = keyof typeof notificationsTranslations;
export type OpenInAppTranslationsKeys = keyof typeof openInAppTranslations;
export type ProfileSettingsTranslationsKeys = keyof typeof profileSettingsTranslations;
export type ReportingCommonTranslationsKeys = keyof typeof reportingCommonTranslations;
export type ReportingCourseReportTranslationsKeys = keyof typeof reportingCourseReportTranslations;
export type ReportingSegmentsTranslationsKeys = keyof typeof reportingSegmentsTranslations;
export type ReportingSkillsReportTranslationsKeys = keyof typeof reportingSkillsReportTranslations;
export type ReportingUserGroupsReportTranslationsKeys = keyof typeof reportingUserGroupsReportTranslations;
export type ReportingUserReportTranslationsKeys = keyof typeof reportingUserReportTranslations;

export type TranslationKeys =
    | AdminApiTokensTranslationsKeys
    | AdminBillingTranslationsKeys
    | AdminBrandingTranslationsKeys
    | AdminCategoriesTranslationsKeys
    | AdminCoursesTranslationsKeys
    | AdminEventsTranslationsKeys
    | AdminGroupsTranslationsKeys
    | AdminTranslationsKeys
    | AdminPlaylistsTranslationsKeys
    | AdminSettingsTranslationsKeys
    | AdminSkillsTranslationsKeys
    | AdminTopicsTranslationsKeys
    | AdminUsersTranslationsKeys
    | AuthenticationTranslationsKeys
    | CommonComponentsTranslationsKeys
    | CommonTranslationsKeys
    | ContentStoreTranslationsKeys
    | CoursesTranslationsKeys
    | EventsTranslationsKeys
    | NotificationsTranslationsKeys
    | OpenInAppTranslationsKeys
    | ProfileSettingsTranslationsKeys
    | ReportingCommonTranslationsKeys
    | ReportingCourseReportTranslationsKeys
    | ReportingSegmentsTranslationsKeys
    | ReportingSkillsReportTranslationsKeys
    | ReportingUserGroupsReportTranslationsKeys
    | ReportingUserReportTranslationsKeys;
